import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface EmptyStateMessageProps {
  entityType?: 'videos';
  title?: string;
  description?: string;
  action?: React.ReactNode | null;
  message?: string;
  actionLabel?: string;
  onAction?: () => void;
}

const EmptyStateMessage: React.FC<EmptyStateMessageProps> = ({ 
  entityType = 'videos',
  title = '',
  description = '',
  action = null,
  message = '',
  actionLabel = '',
  onAction = () => {}
}) => {
  const navigate = useNavigate();
  
  const handleAction = () => {
    if (entityType === 'videos') {
      const currentPath = window.location.pathname;
      
      if (currentPath === '/videos') {
        navigate('/videos/upload');
      } else {
        navigate('/videos/upload');
      }
    }
  };
  
  const defaultTitle = message || (entityType === 'videos' 
    ? 'No videos found' 
    : 'No items found');
    
  const defaultDescription = description || (entityType === 'videos' 
    ? 'Upload your first video to get started.' 
    : 'No items to display.');
    
  const defaultAction = (
    <Button 
      variant="contained" 
      color="primary"
      onClick={onAction || handleAction}
    >
      {actionLabel || (entityType === 'videos' ? 'Upload Video' : 'Add Item')}
    </Button>
  );
  
  return (
    <Box 
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 4
      }}
    >
      {(title || defaultTitle) && (
        <Typography variant="h6" sx={{ mb: 1 }}>
          {title || defaultTitle}
        </Typography>
      )}
      
      <Typography variant="body1" sx={{ mb: 2 }}>
        {defaultDescription}
      </Typography>
      
      {action || defaultAction}
    </Box>
  );
};

export default EmptyStateMessage; 